import { z } from 'zod'

// 254 is the longest address SMTP can carry (RFC 5321); the cap also bounds what a request can make
// the server hash, look up and remember (the login backoff) per attempt
export const emailAddress = z
  .string()
  .email('Invalid email address')
  .max(254, 'Email must not exceed 254 characters')
